'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconInfo, iconInfoTag } from '@ni/nimble-components/dist/esm/icons/info';
import { wrap } from '../../utilities/react-wrapper';

export type { IconInfo };
export { iconInfoTag };
export const NimbleIconInfo = wrap(IconInfo);